import { createFormatDate } from './createDateTimeFormatter';
export function getMonthNames(locale = 'en-GB') {
    const formatDate = createFormatDate({
        locale,
        month: 'long',
        timeZone: 'UTC',
    });
    const months = Array.from({ length: 12 }).map((_, index) => {
        return new Date(`2017-${`${index + 1}`.padStart(2, '0')}-01T00:00:00+00:00`);
    });
    return months.map((date) => formatDate(date));
}
//# sourceMappingURL=getMonthNames.js.map